export { SvgUri } from "react-native-svg";
